export enum FleetsTypes {
  FLEETS_REQUEST = 'appData/fleets/FLEETS_REQUEST',
  FLEETS_SUCCESS = 'appData/fleets/FLEETS_SUCCESS',
  FLEETS_FAILURE = 'appData/fleets/FLEETS_FAILURE',
}
